<template>
  <v-row id="autoservicio-bonus-stepper">
    <v-col
      v-for="item in items" :key="item.step" :step="item.step" :complete="item.isCompleted"
      cols="3"
    >
      <div class="d-flex flex-column">
        <div class="d-flex justify-center">
          <v-chip v-if="!item.isCompleted" :value="item.step">
            {{ item.step }}
          </v-chip>
          <v-icon v-else
            color="green"
            size="30"
          >
            mdi-checkbox-marked-circle
          </v-icon>
        </div>
        <div>
        </div>
        <p style="text-align: center">
          {{ item.text }}
        </p>
      </div>
    </v-col>
  </v-row>
<!--   <v-stepper>
    <v-stepper-header id="as-step-validation">
      <v-stepper-step
        v-for="item in items" v-bind="item.isComleted ? { color: 'green'} : {}"
        :key="item.step" :step="item.step" :complete="item.isCompleted"
      >
        <div class="d-flex justify-center" style="text-align: center">
          {{ item.text }}
        </div>
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper> -->
</template>
<script>
  export default {
    data () {
      return {
        isfalse: false
      }
    },
    props: {
      items: {
        type: Array
      }
    },
    computed: {
      color: (item) => {
        return item.isCompleted ? { color: 'green' } : {}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/autoservicios/autoservicio-step-validation.vue